<template>
  <div class="paas-split">
    <Split v-model="split"  v-height="{offsetHeight:100}">
      <div slot="left">
        <Widget>
          <div slot="head">
            <span class="whead-left-title"><span style="color:red">{{wTitle}}</span>配置字段列表</span>
          </div>
          <div slot="toolbar">

          </div>
          <div ref="listWrap" slot="content" >
            <Table border ref="selection" :columns="configColums"
                   :data="configData" :height="tableHeight" @on-drag-drop="dropNode" draggable></Table>
          </div>
        </Widget>
      </div>
      <div slot="right">
        <Widget>
          <div slot="head">
            <span class="whead-left-title">添加<span style="color:red">{{wTitle}}</span>配置字段</span>
          </div>
          <div slot="toolbar">
            <Button type="default" @click="paasPageBack">返回</Button>
          </div>
          <Form ref="paasForm" slot="content" :label-width="140"  :style="{'height':tableHeight+'px','overflow':'auto','width':'100%'}">
            <Row>
              <FormItem :label-width="0">
                <RadioGroup v-model="type" type="button" @on-change="changeFieldType">
                  <Radio label="text" :type="type==='text'?primary:''">文本框</Radio>
                  <Radio label="textarea" :type="type==='textarea'?primary:''">多行文本框</Radio>
                  <Radio label="radio" :type="type==='radio'?primary:''">单选框</Radio>
                  <Radio label="upload" :type="type==='upload'?primary:''">文件上传</Radio>
                  <Radio label="checkbox" :type="type==='checkbox'?primary:''">多选框</Radio>
                  <Radio label="select" :type="type==='select'?primary:''">下拉框</Radio>
                  <Radio label="entity" :type="type==='entity'?primary:''">下拉实体类</Radio>
                </RadioGroup>
              </FormItem>
            </Row>
            <!--<Row>
              <FormItem label="分类：" prop="configTabName" class="ivu-col-span-20" >
                <Select v-model="paasFormData.configTabId" >
                  <Option v-for="item in entityData" :value="item.id"
                          :key="item.id" :label="item.title">{{item.title}}</Option>
                </Select>
              </FormItem>
            </Row>-->
            <Row v-if="type === 'text'">
              <FormItem label="类型：" prop="inputType" class="ivu-col-span-20" >
                <Enum :enumJsonKey="'crmdict-inputType'"  v-model="paasFormData.inputType"  placeholder="请选择类型"></Enum>

              </FormItem>
            </Row>
            <Row>
              <FormItem label="配置名称：" prop="info" class="ivu-col-span-20" >
                <Input v-model="paasFormData.info"
                       clearable placeholder="请输入配置名称"></Input>

              </FormItem>
            </Row>
            <Row>
              <FormItem label="字段变量：" prop="menuName" class="ivu-col-span-20" >
                <Input v-model="paasFormData.menuName"
                       clearable placeholder="例如：site_url"></Input>

              </FormItem>
            </Row>
            <Row>
              <FormItem label="配置简介：" prop="configDesc" class="ivu-col-span-20" >
                <Input v-model="paasFormData.configDesc"
                       clearable placeholder="请输入配置简介"></Input>

              </FormItem>
            </Row>
            <Row v-if="type === 'entity'">
              <FormItem label="配置参数：" prop="checkParameter" class="ivu-col-span-20 align-left" >
                <Input v-model="paasFormData.checkParameter"
                       clearable :placeholder="JSON.stringify(entityParamPlaceholder)"
                       type="textarea" :autosize="{minRows: 3,maxRows: 5}"></Input>

              </FormItem>
            </Row>
            <Row v-if="type === 'upload'">
              <FormItem label="上传类型：" prop="uploadType" class="ivu-col-span-20 align-left" >
                <Enum :enumJsonKey="'crmdict-uploadType'"  v-model="paasFormData.uploadType"  type="radio" ></Enum>

              </FormItem>
            </Row>
            <Row v-if="type === 'upload'">
              <FormItem label="缩略图宽度：" prop="width" class="ivu-col-span-20 align-left" >
                <Input v-model="paasFormData.width"
                       clearable placeholder="缩略图宽度"></Input>
              </FormItem>
            </Row>
            <Row v-if="type === 'upload'">
              <FormItem label="缩略图高度：" prop="height" class="ivu-col-span-20 align-left" >
                <Input v-model="paasFormData.height"
                       clearable placeholder="缩略图高度"></Input>
              </FormItem>
            </Row>
            <Row v-if="type === 'radio'||type === 'checkbox'||type === 'select'">
              <FormItem label="配置参数：" prop="checkParameter" class="ivu-col-span-20" >
                <Input v-model="paasFormData.checkParameter"
                       clearable :placeholder="paramPlaceholder"
                       type="textarea" :autosize="{minRows: 3,maxRows: 5}"></Input>

              </FormItem>
            </Row>
            <Row v-if="type === 'text' || type === 'textarea' || type === 'radio'">
              <FormItem label="默认值：" prop="defaultValue" class="ivu-col-span-20" >
                <Input v-model="paasFormData.defaultValue"
                       clearable placeholder="请输入默认值"></Input>

              </FormItem>
            </Row>

            <Row v-if="type === 'text' || type === 'textarea'">
              <FormItem label="文本框宽（%）：" prop="width" class="ivu-col-span-20 align-left" >
                <InputNumber v-model="paasFormData.width"></InputNumber>

              </FormItem>
            </Row>
            <Row v-if="type === 'textarea'">
              <FormItem label="多行文本框高（%）：" prop="height" class="ivu-col-span-20 align-left" >
                <InputNumber v-model="paasFormData.height"></InputNumber>

              </FormItem>
            </Row>
            <Row v-if="type === 'text'">
              <FormItem label="验证规则：" prop="requiredRules" class="ivu-col-span-20" >
                <Input v-model="paasFormData.requiredRules"
                       clearable placeholder="多个请用，隔开例如：requir:true,url:true"></Input>

              </FormItem>
            </Row>
            <Row>
              <FormItem label="排序：" prop="displayOrder" class="ivu-col-span-20">
                <Input v-model="paasFormData.displayOrder"
                       clearable placeholder="请输入排序"></Input>

              </FormItem>
            </Row>
            <Row>
              <FormItem label="状态：" prop="status" class="ivu-col-span-20 align-left">
                <Enum :enumJsonKey="'crmdict-isShow'"  v-model="paasFormData.status"  type="radio" ></Enum>

              </FormItem>
            </Row>
            <Row>
              <FormItem :label-width="0">
                <Button type="primary" size="large" @click="paasFormSubmit">提交</Button>
                <Button @click="paasPageBack" size="large" style="margin-left: 8px">返回</Button>
              </FormItem>
            </Row>
          </Form>
        </Widget>
      </div>
    </Split>
  </div>

</template>

<script>
  import Widget from '@/components/paas/widget';
  import wrapperEdit from "@/components/paas/wrapper-edit";
  import Enum from '@/components/paas/enum-form' //枚举渲染
  export default {
    name: "configCreate",
    components:{Widget,wrapperEdit,Enum},
    data(){
        return{
          split:0.45,  //面板位置，可以是 0~1 代表百分比，或具体数值的像素，可用 v-model 双向绑定
          serviceUrl:"/eb/system/config",  //每个页面访问后台服务器的路径
          currentIdFiledName: 'id',
          type:'text',
          wTitle:'',
          tableHeight:'',
          configData:[],
          paramPlaceholder:"参数方式例如：\n1=>男\n2=>女",
          entityParamPlaceholder:'{"requestUrl":" ","idField":" ","nameField":" ","idFieldChild":" ","nameFieldChild":" "}',
          configColums:[
            {
              title: '名称',
              key: 'info'
            },
            {
              title: '字段名',
              key: 'menuName'
            },
            {
              title: '排序',
              key: 'displayOrder'
            },
            {
              title: '类型',
              key: 'fieldType',
              width:80,
            },
            {
              title: '操作',
              align: "center",
              render: (h, params) => {
                return (h('div',[
                  h('Button',{
                    props:{
                      type:'primary',
                    },
                    style:{
                      marginRight:"10px",
                    },
                    on: {
                      click: () => {
                        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/edit?id="+params.row.id).then(res => {
                          if(res.code === 200){
                            this.type = res.data.entity.fieldType;
                            this.paasFormData = res.data.entity;
                          }
                        }).catch(error => {
                          this.$Message.info("数据获取失败")
                        });
                      }
                    }
                  },"修改"),
                  h('Button',{
                    props:{
                      type:'warning',
                    },
                    on: {
                      click: () => {
                        let that = this;
                        this.$swal({
                          title: "您确定要删除这条信息吗",
                          text: "删除后将无法恢复，请谨慎操作！",
                          type: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#DD6B55",
                          confirmButtonText: "是的，我要删除！",
                          cancelButtonText: "让我再考虑一下…",
                          closeOnConfirm: false,
                          closeOnCancel: false
                        }).then((isConfirm)=> {
                          if(isConfirm.value){
                            that.axios.post(that.$store.state.sysApi+that.serviceUrl+"/delete?ids="+params.row.id).then((res)=> {
                              if (res.code === 200) {
                                if(that.configData != null && that.configData.length> 0){
                                  for(let i = 0; i < that.configData.length; i++){
                                    if(that.configData[i].id === params.row.id){
                                      that.configData.splice(i,1);
                                    }
                                  }
                                }
                                that.$Message.success('删除成功!');
                              } else {
                                that.$Message.error('清空失败!');
                              }
                            }).catch((err)=> {
                              that.$Message.error(err);
                            })
                          }
                        }).catch(console.log);
                      }
                    }
                  },"删除"),
                ]))
              }
            }
          ] ,
          wrapperWidth:'90%',
          emptyFormData:{
            inputType:'',
            info:'',
            menuName:'',
            desc:'',
            defaultValue:'',
            requiredRules:'',
            displayOrder:'',
            status:'',
            id:'',
            uploadType:'',
            checkParameter:'',
          },
          paasFormData:{
            configTabId:'',
            configTabName:'',
            inputType:'',
            info:'',
            menuName:'',
            configDesc:'',
            defaultValue:'',
            width:'100',
            height:'5',
            requiredRules:'',
            displayOrder:'',
            status:'',
            id:'',
            uploadType:'',
            checkParameter:'',
            paasRepeatSubmitFlag:'',
            fieldType:'',
          },
        }
    },
    created(){
      this.paasFormData.configTabId = this.$route.query.configTabId;
      this.paasFormData.configTabName =  this.$route.query.configTabName;
      this.wTitle = this.$route.query.configTabName;
      //获取table的数据
      let param = {
        query_EQ_configTabId: this.$route.query.configTabId,
        queryOrderBy_: 'displayOrder@asc',
      };
      this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/getTableData", param).then(res => {
        if(res.code === 200){
          this.configData = res.data.aaData;
          this.getEntityReferData();
        }
      }).catch(error => {
        this.$Message.info("数据获取失败")
      });
    },
    methods:{
      /**
       * 把index1的节点拖动到index2位置
       * */
      dropNode(fromIndex,toIndex){
        /**
         * 获取一个新的数组，更新数组编码
         */
        let dragNewData = [];
        //filter 过滤掉第index1的数据
        dragNewData = this.configData.filter(data => {
          return data[this.currentIdFiledName] !== this.configData[fromIndex][this.currentIdFiledName];
        });
        //把index1数据放到index2位置
        dragNewData.splice(toIndex,0,this.configData[fromIndex]);
        this.paasTreeOrderSave(dragNewData,fromIndex,toIndex);
      },
      /**
       * update排序后的数组数据
       * @param data
       * @param fromIndex
       * @param toIndex
       * */
      paasTreeOrderSave(data,fromIndex,toIndex) {
        let ids = "";
        for(let i = 0; i < data.length; i++) {
          if(ids) {
            ids += ",";
          }
          ids += data[i][this.currentIdFiledName];
        }
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/saveOrderData?ids="+ids)
          .then(res=> {
            if(res.code === 200) {
              //更新table排序
              this.configData = data;
            }
          }).catch(error=> {
          this.$Message.error('排序数据保存失败，请重试！');
        });
      },
      //后台查询数据
      getEntityReferData(){
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/tab/getTableData").then(
          res=>{
            if(res.code === 200){
              this.entityData = res.data.aaData;
            }
          }).catch(error=>{
          this.$Message.info('获取数据失败，请重试！');
        });
      },

      /**
       * 点击关闭逻辑，一般默认跳转list路由页面
       * @param event
       * @param url
       */
      paasPageBack(event, url){
        if(!url) {
          url = "/eb/system/config/tab/list";
        }
        this.$router.push({'path': this.setUrlFuncId(url)});
      },

      setUrlFuncId(url) {
        if(url.indexOf("?") !== -1) {
          url += '&';
        } else {
          url += '?';
        }
        //组装paasCurrentFunctionId=***
        url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
        return url;
      },
      changeFieldType(type){
        //清空数据
        for(let key in this.emptyFormData){
          this.paasFormData[key] = this.emptyFormData[key];
        }
        this.paasFormData.fieldType = type;
      },
      paasFormSubmit(){
        if( this.paasFormData.fieldType === 'entity')   this.paasFormData.checkParameter = JSON.stringify( data)
        let url = this.$store.state.sysApi+this.serviceUrl + "/save";
        this.axios.post(url, this.paasFormData).then(res => {
          if(res.code === 200) {
            this.$Message.info('数据保存成功！');
            //判断table是否有这条数据，没有就加进去
            let isExist = "no";
            for(let i = 0; i < this.configData.length; i++){
              if(this.configData[i].id === res.data.entity.id){
                this.configData[i].info =  res.data.entity.info;
                this.configData[i].menuName =  res.data.entity.menuName;
                this.configData[i].fieldType =  res.data.entity.fieldType;
                this.configData[i].displayOrder  =  res.data.entity.displayOrder;
                this.paasFormData.paasRepeatSubmitFlag = res.data.entity.id;
                isExist = "yes";
                break;
              }
            }
            if(isExist === "no"){
              this.configData.push(res.data.entity);
            }
            this.changeFieldType(this.type);
          }
        }).catch(function (error) {
          this.$Message.error('数据保存失败，请重试！');
        });
      },
      /**
       * 计算table的高度
       * @param flag
       */
      calculateTableHeight(flag){
        let docHeight = document.documentElement.clientHeight; //可见区域的高度
        /**
         * 只能是元组件才有的方法
         * 距离父组件的高度
         * @type {number}
         */
        let queryOffsetTop = this.$refs.listWrap.getBoundingClientRect().top;
        this.tableHeight = docHeight - queryOffsetTop -50;
      },
    },
    mounted(){
      this.$nextTick(() => {
        this.calculateTableHeight();
      })
    },
  }
</script>

<style scoped>
  .paas-split{
    min-width: 1420px;
  }
  .paas-split >>> .ivu-btn{
    padding:2px;
  }
  .paas-split >>> .ivu-split-trigger-con{
    display:none;
  }
  .align-left{
    text-align:left;
  }
</style>
